










import { Vue, Component } from 'vue-property-decorator'
import { mapState, mapGetters } from 'vuex'

@Component({
  computed: {
    ...mapState('environment', ['license', 'licenseLoaded']),
    ...mapGetters('environment', ['isLicenseValid'])
  }
})
export default class LicenseExpiryInfo extends Vue {

  private license: any
  private licenseLoaded!: boolean
  private isLicenseValid!: boolean
  private alertThresholdMonths: number = 3

  get licenseExpiryMessage (): string {
    let msg = ''
    if (this.licenseLoaded) {
      if (this.isLicenseValid) {
        const options = { year: 'numeric', month: 'long', day: 'numeric' }
        const alertThresholdDate = new Date()
        alertThresholdDate.setMonth(alertThresholdDate.getMonth() + this.alertThresholdMonths)
        const expiryDate = new Date(this.license.validTo)
        if (expiryDate < alertThresholdDate) {
          const expiryDateStr = expiryDate.toLocaleDateString(navigator.language, options)
          msg = `${this.$t('licenseExpire.expireOn')} ${expiryDateStr}. ${this.$t('licenseExpire.renew')}`
        }
      } else {
        msg = `${this.$t('license.requestNew')}`
      }
    }
    return msg
  }

}
